import CreditMeter from "./credit_meter"
import UpgradeCreditsButton from "./upgrade_credits_button"
import { remainingPercentage } from "./utils/credits"
import { CreditsBalance } from "shared/utils/credits"

import styles from "./out_of_credits_banner.module.scss"

interface Props {
  balance: CreditsBalance
  // Absent on the top credits plan, which has nothing left to buy.
  onUpgrade?: () => void
}

const OutOfCreditsBanner = ({ balance, onUpgrade }: Props) => (
  <div className={styles["out-of-credits-banner"]}>
    <CreditMeter filled={remainingPercentage(balance)} onDark>
      <div className={styles.headline}>
        <span className={styles.title}>Out of credits</span>
        <span className={styles.count}>
          {balance.remaining}/{balance.monthly_total} left
        </span>
      </div>
      <span className="body-caption">
        You can still create and connect this Applet, but it will be paused until your credits renew or you upgrade.
      </span>
    </CreditMeter>
    {onUpgrade && <UpgradeCreditsButton onClick={onUpgrade} onDark />}
  </div>
)

export default OutOfCreditsBanner
